<template>
  <div class="space-y-6">
    <!-- Satıcı gruplarına göre ürünleri listele -->
    <UCard v-for="(group, vendorId) in cartStore.groupedByVendor" :key="vendorId"
      :ui="{ rounded: 'rounded-none md:rounded-lg' }">
      <!-- Satıcı başlığı -->
      <div class="flex items-center justify-between pb-4">
        <div class="flex items-center space-x-2">
          <UIcon name="i-heroicons-building-storefront" class="w-4 h-4 text-slate-400" />
          <h4 class="text-sm font-medium text-slate-700">
            {{ group.vendor_name }}
          </h4>
        </div>
        <UButton :to="`/magaza/${group.vendor_slug}-m-${group.vendor_id}`" color="gray" variant="ghost" size="xs"
          class="flex items-center space-x-1">
          <span>Mağazaya Git</span>
          <UIcon name="i-heroicons-arrow-right" class="w-3.5 h-3.5" />
        </UButton>
      </div>

      <!-- Satıcının ürünleri -->
      <div class=" divide-slate-100 ">
        <FrontendCartListItem class="border-t first:border-t-0 " v-for="cartItem in group.items" :key="cartItem.id"
          :item="cartItem" />
      </div>
    </UCard>
  </div>
</template>

<script setup>
const cartStore = useCartStore()
</script>
